import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "full-width" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_editable_block_input = _resolveComponent("editable-block-input")!
  const _component_editable_block = _resolveComponent("editable-block")!

  return (_openBlock(), _createBlock(_component_editable_block, {
    title: "Invoice customization",
    layout: "flex-col",
    "model-value": _ctx.invoiceCustomization,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:client', _ctx.client.sys.id, { ..._ctx.invoiceCustomization, ...$event }))),
    "column-count": 1
  }, {
    default: _withCtx(({ editState }) => [
      _createElementVNode("div", _hoisted_1, [
        _cache[1] || (_cache[1] = _createElementVNode("p", null, "Fill in the following information in case you send invoices to this client.", -1)),
        _createVNode(_component_editable_block_input, {
          label: "Invoice disclaimer",
          modelValue: editState.invoice_meta.invoice_disclaimer,
          "onUpdate:modelValue": ($event: any) => ((editState.invoice_meta.invoice_disclaimer) = $event),
          tooltip: "Will be shown on the invoice, for example about the payment term."
        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
        _createVNode(_component_editable_block_input, {
          label: "Bank account ID",
          modelValue: editState.invoice_meta.bank_account_id,
          "onUpdate:modelValue": ($event: any) => ((editState.invoice_meta.bank_account_id) = $event)
        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
        _createVNode(_component_editable_block_input, {
          label: "Business registration ID",
          modelValue: editState.invoice_meta.business_registration_id,
          "onUpdate:modelValue": ($event: any) => ((editState.invoice_meta.business_registration_id) = $event)
        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
        _createVNode(_component_editable_block_input, {
          label: "Tax registration ID",
          modelValue: editState.invoice_meta.tax_registration_id,
          "onUpdate:modelValue": ($event: any) => ((editState.invoice_meta.tax_registration_id) = $event)
        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
        _createVNode(_component_editable_block_input, {
          label: "Logo URL",
          modelValue: editState.logo_uri,
          "onUpdate:modelValue": ($event: any) => ((editState.logo_uri) = $event),
          tooltip: "Fill in the URL of your logo image. This will be shown on the invoice."
        }, null, 8, ["modelValue", "onUpdate:modelValue"])
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}